import {
    BC_GET_TEAMLIST_FOR_COACH_REQUEST,
    BC_GET_TEAMLIST_FOR_COACH_SUCCESS,
    BC_GET_TEAMLIST_FOR_COACH_ERROR,

    BC_UPDATE_COACH_REQUEST,
    BC_UPDATE_COACH_SUCCESS,
    BC_UPDATE_COACH_ERROR,

    BC_ADD_NEW_TEAM_REQUEST,
    BC_ADD_NEW_TEAM_SUCCESS,
    BC_ADD_NEW_TEAM_ERROR,
  } from "../../../../constants/BaseballCloud/Users/AddUser/AddCoach.const";
  
  const initialState = {
    listsReq: false,
    listsData: null,
    listsError: null,

    coachReq: false,
    coachData: null,
    coachError: null,
    coachLoader: false,

    newTeamReq: false,
    newTeamData: null,
    newTeamError: null,
    newTeamLoader: false, 
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
  
      // For GET Team List for coach
      case BC_GET_TEAMLIST_FOR_COACH_REQUEST:
        return {
          ...state,
          listsReq: true,
        };
      case BC_GET_TEAMLIST_FOR_COACH_SUCCESS:
        return {
          ...state,
          listsData: action.payload,
        };
      case BC_GET_TEAMLIST_FOR_COACH_ERROR:
        return {
          ...state,
          listsError: action.error,
        };

            // For coach select a team
      case BC_UPDATE_COACH_REQUEST:
        return {
          ...state,
          coachReq: true,
          coachLoader: true,
        };
      case BC_UPDATE_COACH_SUCCESS:
        return {
          ...state,
          coachData: action.payload,
          coachLoader: true,
        };
      case BC_UPDATE_COACH_ERROR:
        return {
          ...state,
          coachError: action.error,
          coachLoader: true,
        };

        // Add new team for coach user
        case BC_ADD_NEW_TEAM_REQUEST:
        return {
          ...state,
          newTeamReq: true,
          newTeamLoader: true,
        };
      case BC_ADD_NEW_TEAM_SUCCESS:
        return {
          ...state,
          newTeamData: action.payload,
          newTeamLoader: true,
        };
      case BC_ADD_NEW_TEAM_ERROR:
        return {
          ...state,
          newTeamError: action.error,
          newTeamLoader: true,
        };

      default:
        return state;
    }
  }
  